// Import the ShopMenuScene from the modular structure
export { default } from './shopmenu';